// extracted by mini-css-extract-plugin
export default {"time-range":"styles_time-range__9rbOY","timeRange":"styles_time-range__9rbOY"};